import { useTranslation } from "react-i18next";

export default function PlusTax({ compact = false }) {
  const { t } = useTranslation();

  return (
    <span
      className={
        compact
          ? "ml-1 text-xs font-medium tracking-normal opacity-70 whitespace-nowrap"
          : "ml-1.5 text-sm font-medium tracking-normal opacity-70 whitespace-nowrap"
      }
    >
      {t("plusTax")}
    </span>
  );
}
